"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_icons_1 = require("@radix-ui/react-icons");
var react_1 = require("@stitches/react");
var stitches_config_1 = require("../stitches.config");
var StyledSearchBar = (0, react_1.styled)("div", {
    display: "flex",
    border: "1px solid ".concat(stitches_config_1.theme.colors.gray7),
    boxShadow: stitches_config_1.theme.shadows.shadowInner,
    backgroundColor: stitches_config_1.theme.colors.white,
    paddingBlock: "6px",
    paddingInline: "10px",
    borderRadius: "6px",
    "&:hover": {
        border: "1px solid ".concat(stitches_config_1.theme.colors.gray8),
    },
    "&:focus-within": {
        border: "1px solid ".concat(stitches_config_1.theme.colors.blue9),
        boxShadow: "0px 0px 0px 2px ".concat(stitches_config_1.theme.colors.blue7),
    },
});
var InputContainer = (0, react_1.styled)("div", {
    display: "flex",
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    gap: "2px",
});
var StyledInput = (0, react_1.styled)("input", {
    width: "100%",
    border: "none",
    outline: "none",
});
function SearchBar(props) {
    var value = props.value, onChange = props.onChange, placeholder = props.placeholder, containerProps = __rest(props, ["value", "onChange", "placeholder"]);
    return ((0, jsx_runtime_1.jsx)(StyledSearchBar, __assign({}, containerProps, { children: (0, jsx_runtime_1.jsxs)(InputContainer, { children: [(0, jsx_runtime_1.jsx)(react_icons_1.MagnifyingGlassIcon, {}), (0, jsx_runtime_1.jsx)(StyledInput, { ref: props.inputRef, autoComplete: "do-not-autofill", placeholder: placeholder || "Search", value: value, onChange: onChange })] }) })));
}
exports.default = SearchBar;
//# sourceMappingURL=SearchBar.js.map